import { render, staticRenderFns } from "./ReserveOrderEdit.vue?vue&type=template&id=20f15802&scoped=true&"
import script from "./ReserveOrderEdit.vue?vue&type=script&lang=js&"
export * from "./ReserveOrderEdit.vue?vue&type=script&lang=js&"
import style0 from "./ReserveOrderEdit.vue?vue&type=style&index=0&id=20f15802&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20f15802",
  null
  
)

export default component.exports